import React, { useState, useEffect, useMemo } from "react";
import {
  getAllAvivit,
  cleanAll,
  setBelogs,
  setDone,
} from "../../store/reducers/todosReducer";
import { toast } from "react-toastify";
import FilledLoading from "../common/loader/FilledLoading";
import OpacityLoading from "../common/loader/OpacityLoading";
import { useSelector, useDispatch } from "react-redux";
import ClientRoutes from "../../navigation/Routes";
import {
  FlexRowBetween,
  GenericDiv,
  ListHolder,
  TextWithPic,
  TodoCard,
} from "../common/Style";
import ToolsOptions from "../user/ToolsOptions";
import GenericModal from "../common/modals/GenericModal";
import { useHistory } from "react-router-dom";
import LogoutSpecipic from "../common/LogOut/LogoutSpecipic";
import tools from "../../assets/common/menu.svg";
import excel from "../../assets/common/excel.svg";
import logout from "../../assets/common/logout.svg";
import sms from "../../assets/common/sms.svg";
import whatsapp from "../../assets/common/whatsapp.svg";
import refresh from "../../assets/common/refresh.svg";
import BottomMenu from "../common/others/BottomMenu";
import Switcher from "../common/switcher/Switcher";
import {
  aviadPayment,
  copyToClipBoard,
  days,
  exportToCSV,
  igalPmPayment,
  liorWDPayment,
  msg4,
  msg4B,
  msg4nBS,
  msg4nC,
  TipTopPayment,
  yosefPayment,
} from "../common/others/Functions";
import {
  countNotAnswered,
  getPhoneNumber,
} from "../../store/reducers/dataReducer";
import CopyText from "../common/others/CopyText";
import { getAll, getAllGAvivit } from "../../store/reducers/guestsReducer";

const AvivitTodos = () => {
  const dispatch = useDispatch();
  const [showLoading, setShowLoading] = useState(false);
  const { dataLoading } = useSelector((state) => state.dataReducer);
  const { todos } = useSelector((state) => state.todosReducer);
  let history = useHistory();
  const [showLogout, setShowLogout] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const [firstMsg, setFirstMsg] = useState(false);

  const handleGetAll = () => {
    setShowLoading(true);
    dispatch(getAllAvivit()).then((res) => {
      if (res.payload?.error) toast.error(res.payload?.error);
      setShowLoading(false);
    });
  };

  const getAllExcel = (guests) => {
    let arr = [];
    if (Object.keys(guests).length > 0)
      for (const [key, value] of Object.entries(guests)) {
        arr.push({
          "שם מלא": value.name,
          "מס׳ נייד": value.phone,
          קירבה: value.closeness,
          מוזמנים: value.sum,
          אישרו: value.accept === null ? "" : value.accept,
          מזמין: value.inviting,
          קשר: value.owc,
          הערות: value.notes,
        });
      }
    exportToCSV(arr, "כללי");
  };

  const handleGetGuests = (uid) => {
    setShowLoading(true);

    dispatch(getAllGAvivit(uid)).then((res) => {
      if (res.payload?.error) toast.error(res.payload?.error);
      else getAllExcel(res.payload);
      setShowLoading(false);
    });
  };

  const handleCountNotAnswered = (uid) => {
    setShowLoading(true);
    dispatch(countNotAnswered({ uid })).then((res) => {
      if (res.payload?.error) toast.error(res.payload?.error);
      else
        toast.info(
          <FlexRowBetween>
            {res.payload.isReadyAdmin ? (
              <div style={{ width: "30%" }}>{`האירוע מוכן${
                res.payload.isReady ? "" : " אך לא לחצו על הכפתור"
              }`}</div>
            ) : (
              <>
                <div>{res.payload.waze.length ? "✔️" : "❌"}</div>
                <div>{res.payload.amount}</div>
                <img
                  src={excel}
                  style={{ width: "25px" }}
                  onClick={() => {
                    if (res.payload.eventType) handleGetGuests(uid);
                    else
                      toast.info(
                        "לא מדובר בחתונה ולכן אין אפשרות למזמין + קשר"
                      );
                  }}
                />
              </>
            )}
            <CopyText
              marginLeft={"5px"}
              dataToCopy={res.payload.phone}
              text={res.payload.phone}
            />
          </FlexRowBetween>
        );

      setShowLoading(false);
    });
  };

  const handleBeforePayment = (uid) => {
    setShowLoading(true);
    dispatch(countNotAnswered({ uid })).then((res) => {
      if (res.payload?.error) toast.error(res.payload?.error);
      else
        toast.info(
          <FlexRowBetween>
            <a
              onClick={() =>
                copyToClipBoard(
                  res.payload.producer == "משחק הכיסאות"
                    ? aviadPayment
                    : res.payload.producer == "מארגנת החתונות"
                    ? liorWDPayment
                    : res.payload.producer == "שמחת עולם"
                    ? yosefPayment
                    : res.payload.producer == "TipTop"
                    ? TipTopPayment
                    : res.payload.producer == "PM ניהול והפקות אירועים"
                    ? igalPmPayment
                    : res.payload.paybox !== "" && res.payload.paybox !== null
                    ? msg4B
                    : msg4nBS
                )
              }
              target="_blank"
              rel="noreferrer"
              href={`https://wa.me/972${res.payload.phone}/?text=`}
            >
              <img src={whatsapp} alt={"whatsapp"} style={{ width: "31px" }} />
            </a>
            <CopyText
              marginLeft={"5px"}
              dataToCopy={
                res.payload.paybox !== "" && res.payload.paybox !== null
                  ? msg4B
                  : msg4nBS
              }
              text={"טקסט"}
            />

            <CopyText
              marginLeft={"5px"}
              dataToCopy={res.payload.phone}
              text={"נייד"}
            />
          </FlexRowBetween>
        );

      setShowLoading(false);
    });
  };

  const handleCheck1 = (uid) => {
    setShowLoading(true);
    dispatch(getPhoneNumber({ uid })).then((res) => {
      if (res.payload?.error) toast.error(res.payload?.error);
      else
        toast.info(
          <FlexRowBetween>
            <a
              target="_blank"
              rel="noreferrer"
              href={`https://wa.me/972${res.payload.phone}/?text=לקוח יקר, אנא כנס למערכת, תפריט, לו״ז, ולחץ על המשימה שיש להיום ופעל בהתאם`}
            >
              <img src={whatsapp} alt={"whatsapp"} style={{ width: "31px" }} />
            </a>
            <CopyText
              marginLeft={"5px"}
              dataToCopy={res.payload.phone}
              text={res.payload.phone}
            />
          </FlexRowBetween>
        );
      setShowLoading(false);
    });
  };

  const handleSetBelogs = async (id, uid, belongs) => {
    setShowLoading(true);
    dispatch(countNotAnswered({ uid })).then((res) => {
      if (res.payload?.error) toast.error(res.payload?.error);
      else {
        if (res.payload.isReadyAdmin && !res.payload.isReady)
          toast.warning(
            "האירוע מוכן אך הלקוח לא לחץ על הכפתור בעמוד הדרכות שמאפשר תחילת תהליך"
          );
        else if (!res.payload.isReadyAdmin && res.payload.isReady)
          toast.warning(
            "הלקוח לחץ על הכפתור אבל את לא סימנת שהאירוע מוכן בתיק לקוח - לבדוק האם מוכן מבחינתך"
          );
        else if (!res.payload.isReadyAdmin && !res.payload.isReady)
          toast.warning("גם את וגם הלקוח לא לחצתם שמוכן");
        else if (res.payload.isReadyAdmin && res.payload.isReady) {
          const body = { belongs };
          dispatch(setBelogs(id, body)).then((res) => {
            if (!res.payload?.error) {
              toast.success("הפעולה בוצעה בהצלחה");
            } else toast.error(res.payload?.error);
          });
        }
      }
      setShowLoading(false);
    });
  };

  const handleSetDone = async (id, done) => {
    const body = { done };
    dispatch(setDone(id, body)).then((res) => {
      if (!res.payload?.error) {
        toast.success("הפעולה בוצעה בהצלחה");
      } else toast.error(res.payload?.error);
    });
  };

  useEffect(() => {
    handleGetAll();
    return () => {
      dispatch(cleanAll());
    };
  }, []);

  let todosArray = useMemo(() => {
    let today = new Date();
    let arr = [];
    let sortedArray = [];
    if (Object.keys(todos).length > 0) {
      for (const [key, value] of Object.entries(todos))
        if (firstMsg) {
          if (value.title == "הודעה ראשונה") sortedArray.push(value);
        } else if (value.title != "הודעה ראשונה") sortedArray.push(value);

      sortedArray.sort(
        (a, b) => new Date(a["executionDate"]) - new Date(b["executionDate"])
      );
      for (let i = 0; i < sortedArray.length; i++)
        arr.push(
          <TodoCard
            style={{
              borderRight:
                days(new Date(), new Date(sortedArray[i].executionDate)) == 0
                  ? "5px solid #7b96c4"
                  : "none",
              cursor: "text",
            }}
            key={i}
          >
            <div
              onClick={() => {
                if (sortedArray[i].title == "הסדרת תשלום")
                  handleBeforePayment(sortedArray[i].uid);
                else handleCountNotAnswered(sortedArray[i].uid);
              }}
            >
              {sortedArray[i].title}
            </div>
            <div>
              <div style={{ fontSize: "13px" }}>
                {sortedArray[i].executionDate
                  .replace(/T.*/, "")
                  .split("-")
                  .reverse()
                  .join("/")}
              </div>
              <div>{sortedArray[i].company}</div>
            </div>

            {/* {(sortedArray[i].title.split(" ")[0] === "לבדוק" ||
              sortedArray[i].title.split(" ")[0] === "לוודא") && (
              <GenericDiv
                onClick={() => handleCheck1(sortedArray[i].uid)}
                background={"rgba(123,150,196,0.95)"}
                style={{ margin: "0 20px", padding: "4px 4px" }}
              >
                בדיקה
              </GenericDiv>
            )} */}

            <div
              style={{ width: "min-content" }}
              onClick={(e) => e.stopPropagation()}
            >
              <Switcher
                onOfColor={"#C0C0C0"}
                color={"#7b96c4"}
                checked={
                  sortedArray[i].title.split(" ")[0] === "הודעה"
                    ? sortedArray[i].belongs
                    : sortedArray[i].done
                }
                onChange={() => {
                  if (sortedArray[i].title.split(" ")[0] === "הודעה")
                    handleSetBelogs(
                      sortedArray[i]._id,
                      sortedArray[i].uid,
                      !sortedArray[i].belongs
                    );
                  else handleSetDone(sortedArray[i]._id, !sortedArray[i].done);
                }}
                // {() =>
                //   handleSetDone(sortedArray[i]._id, !sortedArray[i].done)
                // }
              />
            </div>
          </TodoCard>
        );
    }
    return arr;
  }, [todos, firstMsg]);

  return (
    <div
      style={{
        width: "100%",
        height: `${window.screen.availHeight}px`,
      }}
    >
      <BottomMenu
        data={[
          <img
            key={1}
            src={refresh}
            alt="refresh"
            style={{ width: "23px", padding: "10px 0", cursor: "pointer" }}
            onClick={handleGetAll}
          />,
          <img
            key={2}
            src={tools}
            alt="tools"
            style={{ width: "31px", padding: "10px 0", cursor: "pointer" }}
            onClick={() => setShowMenu(true)}
          />,
          <img
            key={3}
            src={logout}
            alt="logout"
            style={{ width: "31px", padding: "10px 0", cursor: "pointer" }}
            onClick={() => setShowLogout(true)}
          />,
        ]}
      />
      <FlexRowBetween
        style={{
          height: "70px",
          alignItems: "center",
          justifyContent: "center",
          position: "fixed",
          marginBottom: "100px",
          zIndex: 1,
          background: "white",
          boxShadow: "0 2px 4px #f2f2f2",
        }}
      >
        <div style={{ marginLeft: "20px" }}>הודעה ראשונה</div>
        <Switcher
          onOfColor={"#C0C0C0"}
          color={"#7b96c4"}
          checked={firstMsg}
          onChange={() => setFirstMsg(!firstMsg)}
        />
        <div style={{ marginRight: "20px" }}>כל השאר</div>
      </FlexRowBetween>
      <ListHolder style={{ marginTop: "90px" }}>{todosArray}</ListHolder>
      <div style={{ height: "100px" }} />

      {showLoading && <FilledLoading />}
      {dataLoading && <OpacityLoading />}
      {showLogout && (
        <GenericModal
          init={setShowLogout}
          div={<LogoutSpecipic init={setShowLogout} />}
        />
      )}

      {showMenu && (
        <GenericModal
          init={setShowMenu}
          div={
            <ToolsOptions
              data={[
                <TextWithPic
                  key={1}
                  onClick={() => history.push(ClientRoutes.Admin.main)}
                >
                  ראשי
                </TextWithPic>,
                // <TextWithPic
                //   onClick={() => history.push(ClientRoutes.Admin.todos)}
                //   key={2}
                // >
                //   משימות
                // </TextWithPic>,
              ]}
            />
          }
        />
      )}
    </div>
  );
};

export default AvivitTodos;
